import React from 'react';
import { string } from 'prop-types';

const TextWithBoldSubstr = ({ str, substr }) => {
  const substrLoc = str.toUpperCase().indexOf(substr.toUpperCase());
  const substrEndLoc = substrLoc + substr.length;

  const startingText = str.substr(0, substrLoc);
  const boldPortion = str.substring(substrLoc, substrEndLoc);
  const endingText = str.substr(substrEndLoc);

  return (
    <>
      {startingText && <span>{startingText}</span>}
      <strong style={{ fontWeight: 'bold' }}>{boldPortion}</strong>
      {endingText && <span>{endingText}</span>}
    </>
  );
};

TextWithBoldSubstr.defaultProps = {
  str: '',
  substr: ''
};

TextWithBoldSubstr.propTypes = {
  str: string,
  substr: string
};

export default TextWithBoldSubstr;
